import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Layoutviewpage from "../../../components/common/View/View-Layout";
import { RxValue } from "react-icons/rx";

function AdminPlanView() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({});

  const viewPlan = location?.state?.data;

  const fields = [
    { name: "gym_name", label: "GYM Name",  type: "text", placeholder: "Enter GYM Name", hidden: false },
    { name: "domain", label: "Domain", type: "text", placeholder: "Enter Domain Name", hidden: false },
    { name: "plan_type", label: "Plan Type", type: "text", placeholder: "Enter Plan Type", hidden: false },
    { name: "plan_end_date", label: "Plan End Date", type: "date", placeholder: "Enter Plan End Date", hidden: false },
    { name: "plan_duration_type", label: "Plan Duration Type", type: "text", placeholder: "Enter Duration Type", hidden: false },
  ];
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; 
  };

  useEffect(() => {

    if (viewPlan) {
      setInitialValues({
        gym_name: viewPlan.plan_name || "",
        domain: viewPlan.domain || "",
        plan_type: viewPlan.plan_type || "",
        plan_end_date: formatDate(viewPlan.plan_end_date) || "",
        plan_duration_type: viewPlan.plan_duration_type || "",
      });
      setLoading(false)
    }
  }, [viewPlan,loading]);

  const handleCancel = () => {
    navigate("/adminplan-list",{ state: { pageName: "AdminPlan" }});
  };

  return (

    <div className="pb-4 pt-3">
      {loading == false ? 
      <Layoutviewpage
        title="View AdminPlan"
        onCancel={handleCancel}
        loading={loading}
        fields={fields}
        initialValues={initialValues} 
      /> :  ''}
    </div> 
  );

    
}

export default AdminPlanView;
